import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  SAVE_PREFERENCES_START,
  SAVE_PREFERENCES_SUCCESS,
  SAVE_PREFERENCES_ERROR,
  SAVE_PREFERENCES_LOADING,
  SAVE_PREFERENCES_CANCEL,
} from '@src/app/accounts/preferences';

export type State = {
  readonly loading: boolean;
  preferenceSavedResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case SAVE_PREFERENCES_START:
      case SAVE_PREFERENCES_SUCCESS:
      case SAVE_PREFERENCES_ERROR:
        return false;
      case SAVE_PREFERENCES_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  preferenceSavedResult: (state = null, action) => {
    switch (action.type) {
      case SAVE_PREFERENCES_ERROR:
      case SAVE_PREFERENCES_SUCCESS:
        return action.payload;
      case SAVE_PREFERENCES_START:
      case SAVE_PREFERENCES_CANCEL:
          return null;
      default:
        return state;
    }
  },
});
